/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ months: NonNullable<unknown>, rate: NonNullable<unknown> }} Admin_Billing_Batch_Tier_LabelInputs */

const es_admin_billing_batch_tier_label = /** @type {(inputs: Admin_Billing_Batch_Tier_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months}+ meses: ${i?.rate}% off`)
};

const en_admin_billing_batch_tier_label = /** @type {(inputs: Admin_Billing_Batch_Tier_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months}+ months: ${i?.rate}% off`)
};

/**
* | output |
* | --- |
* | "{months}+ months: {rate}% off" |
*
* @param {Admin_Billing_Batch_Tier_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_tier_label = /** @type {((inputs: Admin_Billing_Batch_Tier_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Tier_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_tier_label(inputs)
	return en_admin_billing_batch_tier_label(inputs)
});
export { admin_billing_batch_tier_label as "admin.billing.batch.tier_label" }